var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.75C2.58579 2.75 2.25 3.08579 2.25 3.5C2.25 3.91421 2.58579 4.25 3 4.25H4.25V19.4656C4.25 20.9186 5.91841 21.7387 7.06891 20.8512L8.39974 19.8246C8.48344 19.76 8.59871 19.7551 8.68763 19.8122L10.5129 20.9856C11.4188 21.568 12.5812 21.568 13.4871 20.9856L15.3124 19.8122C15.4013 19.7551 15.5166 19.76 15.6003 19.8246L16.9311 20.8512C18.0816 21.7387 19.75 20.9186 19.75 19.4656V4.25H21C21.4142 4.25 21.75 3.91421 21.75 3.5C21.75 3.08579 21.4142 2.75 21 2.75H3ZM8.25 9.5C8.25 9.08579 8.58579 8.75 9 8.75H12C12.4142 8.75 12.75 9.08579 12.75 9.5C12.75 9.91421 12.4142 10.25 12 10.25H9C8.58579 10.25 8.25 9.91421 8.25 9.5ZM9 12.75C8.58579 12.75 8.25 13.0858 8.25 13.5C8.25 13.9142 8.58579 14.25 9 14.25H12C12.4142 14.25 12.75 13.9142 12.75 13.5C12.75 13.0858 12.4142 12.75 12 12.75H9ZM14.25 9.5C14.25 9.08579 14.5858 8.75 15 8.75H15.5C15.9142 8.75 16.25 9.08579 16.25 9.5C16.25 9.91421 15.9142 10.25 15.5 10.25H15C14.5858 10.25 14.25 9.91421 14.25 9.5ZM15 12.75C14.5858 12.75 14.25 13.0858 14.25 13.5C14.25 13.9142 14.5858 14.25 15 14.25H15.5C15.9142 14.25 16.25 13.9142 16.25 13.5C16.25 13.0858 15.9142 12.75 15.5 12.75H15Z",
    fill: "#40474B",
    stroke: "#CAE9FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyEvents);
export default __webpack_public_path__ + "static/media/my_events.3c3ffc5f53927f02c4ed60329a8ee1e4.svg";
export { ForwardRef as ReactComponent };